const userAvatars = [
    require('../images/avatar_alligator.png'),
    require('../images/avatar_ant.png'),
    require('../images/avatar_bear.png'),
    require('../images/avatar_bee.png'),
    require('../images/avatar_blowfish.png'),
    require('../images/avatar_bluewhale.png'),
    require('../images/avatar_boar.png'),
    require('../images/avatar_bunny.png'),
    require('../images/avatar_cat.png'),
    require('../images/avatar_catapillar.png'),
    require('../images/avatar_chick.png'),
    require('../images/avatar_clownfish.png'),
    require('../images/avatar_cow.png'),
    require('../images/avatar_dog.png'),
    require('../images/avatar_dragon.png'),
    require('../images/avatar_eagle.png'),
    require('../images/avatar_fish.png'),
    require('../images/avatar_fox.png'),
    require('../images/avatar_frog.png'),
    require('../images/avatar_ghost.png'),
    require('../images/avatar_giraffe.png'),
    require('../images/avatar_gorilla.png'),
    require('../images/avatar_hamster.png'),
    require('../images/avatar_horse.png'),
    require('../images/avatar_koala.png'),
    require('../images/avatar_ladybug.png'),
    require('../images/avatar_lion.png'),
    require('../images/avatar_monkey.png'),
    require('../images/avatar_mouse.png'),
    require('../images/avatar_owl.png'),
    require('../images/avatar_panda.png'),
    require('../images/avatar_penguin.png'),
    require('../images/avatar_pig.png'),
    require('../images/avatar_poodle.png'),
    require('../images/avatar_sheep.png'),
    require('../images/avatar_snail.png'),
    require('../images/avatar_snake.png'),
    require('../images/avatar_tiger.png'),
    require('../images/avatar_turtle.png'),
    require('../images/avatar_whale.png'),
    require('../images/avatar_wolf.png')
]

const userColors = [
    'rgba(93, 129, 236, 1)',
    'rgba(248, 248, 248, 1)',
    'rgba(102, 102, 102, 1)',
    'rgba(158, 168, 186, 1)',
    'rgba(168, 139, 255, 1)',
    'rgba(137, 225, 148, 1)',
    'rgba(255,123, 132, 1)',
    'rgba(76, 208, 229, 1)',
    'rgba(255, 200, 98, 1)',
    'rgba(68, 80, 116, 1)',
    'rgba(214, 45, 160, 1)',
    'rgba(255, 156, 228, 1)',
    'rgba(116, 199, 255, 1)',
    'rgba(34, 220, 185, 1)',
    'rgba(255, 255, 255, 1)',
    'rgba(39, 157, 176, 1)',
    'rgba(199, 231, 85, 1)',
    'rgba(255, 138, 67, 1)',
]

export function getAvatar(identity) {
    let badgeImage = require('../images/avatar_default.png')
    let badgeStyle = {}

    if ('undefined' !== typeof identity) {
        if (
            identity &&
            identity.badge_image != null &&
            identity.badge_image.url != null
        ) {
            badgeImage = { uri: identity.badge_image.url }
        } else {
            const int = parseInt(identity.id.replace('-', ''), 16)

            badgeImage = userAvatars[int % userAvatars.length]
            badgeStyle = { backgroundColor: userColors[int % userColors.length] }
        }
    }

    return { badgeImage, badgeStyle }
}



// WEBPACK FOOTER //
// ./src/lib/avatarTools.js